const BillingTypeOptions = [
   {
      value: 'all',
      label: 'All',
      id: 'all',
      name: 'All',
   },
   {
      value: 'C',
      label: 'Credit Card',
      id: 'C',
      name: 'Credit Card',
   },
   {
      value: 'I',
      label: 'Invoice',
      id: 'I',
      name: 'Invoice',
   },
];

export default BillingTypeOptions;
